import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import HelloSign from 'hellosign-embedded';

@Component({
  selector: 'app-embedded-sign',
  templateUrl: './embedded-sign.component.html',
  styleUrls: ['./embedded-sign.component.css']
})
export class EmbeddedSignComponent implements OnInit {

  done = false;

  constructor(
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['clientId'] && params['url']) {
        const client = new HelloSign({
          clientId: params['clientId']
        });

        client.open(atob(params['url']), {
          clientId: params['clientId'],
          skipDomainVerification: true
        });

        client.on('finish', () => {
          window.close();
          this.done = true;
        });
      }
    });
  }

}
